// Api Urls

const urlConfigs = {
  login: 'api/v1/Authorize/GenerateToken',
  associate: 'api/v1/BasicAuth/GetAssociate',
  getAssociate: 'api/v1/Associate/GetAssociate',
  getAssociates: 'api/v1/Associate/GetAssociates',
  calculateTotalPrice: 'api/v1/Order/CalculateOrder',
  getAvailableMerchant: 'api/v1/Merchant/GetAvailableMerchant',
  getWallet: 'api/v1/Wallet/GetWalletBalance',
  getHash: 'api/v1/Associate/GetIntercomHash',
  getAutoship: 'api/v1/AutoShip/GetAutoShipByAssociateId',
  getAutoshipByAutoShipId: 'api/v1/AutoShip/GetAutoShipByAutoShipId',
  updateAutoShip: 'api/v1/AutoShip/UpdateAutoShip',
  processAutoship: 'api/v1/AutoShip/ProcessAutoShip',
  getCompleteOrderDetails: 'api/v1/Order/GetCompleteOrderDetails',
  getOrders: 'api/v1/Order/GetOrderDetails',
  defiverse: 'api/v1/Defivrse/GetURL',
  getOrderLog: 'api/v1/Order/GetOrderLog',
  getWalletTransactions: 'api/v1/Wallet/GetWalletTransactions',
  createTygaUser: 'api/v1/Associate/CreateTygaUser',
  payoutFund: 'api/v1/Wallet/PayoutFund',
  transferFund: 'api/v1/Wallet/TransferFund',
  getTyagaUser: 'api/v1/Associate/GetTygaUser',
  getPayment: 'api/v1/Associate/GetPayment',
  getUnProcessedAutoShip: 'api/v1/AutoShip/GetAllUnProcessedAutoShips',
  submitProcessForAutoship: 'api/v1/AutoShip/SubmitAutoshipsForPorcessing',
  getSubscriptionItems: 'api/v1/Subscription/GetSubscriptionItems',
  createSubscriptionItem: 'api/v1/Subscription/CreateSubscriptionItem',
  createServiceItem: 'api/v1/Subscription/CreateServiceItem',
  getSubscription: 'api/v1/Subscription/GetSubscription',
  createSubscription: 'api/v1/Subscription/CreateSubscription',
  getVisibilitySubscription: 'api/v1/Subscription/GetSubscriptionVisibilityItems',
  createInventoryVisibility: 'api/v1/Subscription/CreateSubscriptionInventoryVisibility',
  getVisibilityItemsByAssociate:
    'api/v1/Subscription/GetSubscriptionVisibilityItemsByAssociate',
  getAssociateSubscription: 'api/v1/Subscription/GetAssociateSubscription',
  getAlertList: 'api/v1/Associate/GetAlertList',
  createAlert: 'api/v1/Associate/CreateAlert',
  updateAlert: 'api/v1/Associate/UpdateAlert',
  updateAssociate: 'api/v1/Associate/UpdateAssociate',
  getAssociateReports: 'api/v1/AssociateReport/GetAssociateReport',
  getFieldReport: 'api/v1/AssociateReport/GetFieldReport',
  getFilters: 'api/v1/AssociateReport/GetFieldReportFieldOptions',
  getMerchantById: 'api/v1/Merchant/GetMerchantById',
  deleteMerchant: 'api/v1/Merchant/DeleteMerchant',
  deleteSavedCard: 'api/v1/Merchant/DeleteSavedCard',
  removeSubscriptionItems: 'api/v1/Subscription/RemoveSubscriptionItems',
  validatePhone: 'api/v1/BasicAuth/ValidateAssociatePhone',
  getInvestment: 'api/v1/Investment/GetInvestments',
  createUpdatePreferredInvestment: 'api/v1/Investment/CreateUpdatePreferredInvestment',
  createAssociateReport: 'api/v1/AssociateReport/CreateAssociateReport',
  updateAssociateReport: 'api/v1/AssociateReport/UpdateAssociateReport',
  nmiTokenize: 'api/v1/Merchant/NMITokenize',
  updateAssociateSubscription: 'api/v1/Subscription/UpdateAssociateSubscription',
  getAssociateByEnrollerId: 'api/v1/Associate/GetAssociatebyEnrollerId',
  getLeaderBoard: 'api/v1/AssociateReport/GetLeaderBoard',
  getAssociateStatuses: 'api/v1/Associate/GetAssociateStatuses',
  SyncAssociate: 'api/v1/PillarsExport/FixAssociates',
  updateAssociateStatus: 'api/v1/Associate/UpdateAssociateStatus',
  getCouponCodes: 'api/v1/Coupon/GetCouponCodes',
  createCoupon: 'api/v1/Coupon/CreateCoupon',
  updateCoupon: 'api/v1/Coupon/UpdateCoupon',
  validateAssociateEmail: 'api/v1/BasicAuth/ValidateAssociateEmail',
  createOTP: 'api/v1/Associate/CreateOTP',
  validateOTP: 'api/v1/Associate/ValidateOTP',
  getAssociateAlertList: 'api/v1/Associate/GetAssociateAlertList',
  createAssociateAlert: 'api/v1/Associate/CreateAssociateAlert',
  deleteCoupon: 'api/v1/Coupon/DeleteCoupon',
  imageUpload: 'api/v1/Waiver/ImageUpload',
  getAssociateDetailedReport: 'api/v1/AssociateReport/GetAssociateDetailedReport',
  getEventBySource: 'api/v1/Configuration/GetEventBySource',
  getEventTypes: 'api/v1/Configuration/GetEventTypes',
  createEvent: 'api/v1/Configuration/CreateEvent',
  updateEvent: 'api/v1/Configuration/UpdateEvent',
  getUserCustomers: 'api/v1/Associate/GetUserCustomers',
  insertRecentAssociates: 'api/v1/Associate/InsertRecentAssociates',
  addWalletProspect: 'api/v1/Wallet/AddWalletProspect',
  getUsers: 'api/v1/User/GetUsers',
  getRoles: 'api/v1/User/GetRoles',
  createUsers: 'api/v1/User/CreateUsers',
  updateUserRole: 'api/v1/User/UpdateRole',
  editPassword: 'api/v1/User/EditPassword',
  deleteSubscription: 'api/v1/Subscription/DeleteSubscription',
  getGlossaryByCategory: 'api/v1/Communication/GetGlossaryByCategory',
  getAllGlossaryTerms: 'api/v1/Communication/GetAllGlossaryTerms',
  createGlossaryTerm: 'api/v1/Communication/CreateGlossaryTerm',
  updateGlossaryTerm: 'api/v1/Communication/UpdateGlossaryTerm',
  getAllFAQs: 'api/v1/Communication/GetAllFAQs',
  createFAQ: 'api/v1/Communication/CreateFAQ',
  updateFAQ: 'api/v1/Communication/UpdateFAQ',
  getCategoryFAQ: 'api/v1/Communication/GetCategoryFAQ',
  deactivateUser: 'api/v1/User/DeactivateUser',
  getGroupVolumeValues: 'api/v1/AssociateReport/GetGroupVolumeValues',
  addUpdateGroupVolumeChart: 'api/v1/AssociateReport/AddUpdateGroupVolumeChart',
  removePayment: 'api/v1/Associate/RemovePayment',
  deleteGroupVolumeChart: 'api/v1/AssociateReport/DeleteGroupVolumeChart',
  getAssociateGVDetails: 'api/v1/AssociateReport/GetAssociateGroupVolumeDetails',
  deletePreferredInvestment: 'api/v1/Investment/DeletePreferredInvestment',
  get4xAccount: 'api/v1/Subscription/Get4xAccount',
  add4xProduct: 'api/v1/Subscription/Add4xProduct',
  switch4xProduct: 'api/v1/Subscription/Switch4xProduct',
  getAssociateLogs: 'api/v1/Associate/GetAssociateLogs',
  createManaraAccount: 'api/v1/Associate/CreateMaitryxAccount',
  addUpdateTelegramDetails: 'api/v1/Subscription/AddUpdateTelegramDetails',
  getTelegramDetails: 'api/v1/Subscription/GetTelegramDetails',
  getAllTelegramGroup: 'api/v1/Subscription/GetAllTelegramGroup',
  createTelegramGroupLink: 'api/v1/Subscription/CreateTelegramGroupLink',
  updateAssociateEmail: 'api/v1/Associate/UpdateAssociateEmail',
  update4xProductName: 'api/v1/Subscription/Update4xProductName',
  getRankBreakDown: 'api/v1/AssociateReport/GetRankBreakDown',
  getActivityDetailedReport: 'api/v1/Associate/GetActivityDetailedReport',
  getSolexxDetails: 'api/v1/Subscription/GetSolexxDetails',
  createSolexx: 'api/v1/Subscription/CreateSolexxAccount',
  getSSOToken: 'api/v1/Authorize/GetSSOToken',
  sendForgotPasswordEmail: 'api/v1/BasicAuth/SendForgotPasswordEmail',
  updatePasswordWithOTP: 'api/v1/BasicAuth/UpdatePasswordWithOTP',
  getRegion: 'api/v1/Product/GetRegion',
  getMerchants: 'api/v1/Merchant/GetMerchants',
  payOrder: 'api/v1/Order/PayOrder',
  redundPayment: 'api/v1/Order/RefundPayment',
  associateSearch: 'api/v1/Associate/AssociateSearch',
  cancelAutoShip: 'api/v1/AutoShip/CancelAutoShip',
  resetPassword: 'api/v1/Associate/ResetPassword',
  deleteEvent: 'api/v1/Configuration/DeleteEvent',
  updateSubscription: 'api/v1/Subscription/UpdateSubscription',
  // addWalletProspect:'api/v1/Wallet/AddWalletProspect'
  createTygaBankUser: 'api/v1/Associate/CreateTygaBankUser',
  getKPIs: 'api/v1/Associate/GetKPIs',
  createAssociateLog: 'api/v1/BasicAuth/CreateAssociateLog',
  getTygaBankSSO: 'api/v1/Associate/GetTygaBankSSO',
  updateOrder: 'api/v1/Order/UpdateOrder',
  removeSubscriptionInventoryVisibility:
    'api/v1/Subscription/RemoveSubscriptionInventoryVisibility',
  getAssociateFaviourites: 'api/v1/Associate/GetAssociateFavorites',
  addAssociateFaviourites: 'api/v1/Associate/AddAssociateFavorite',
  updateAssociateFaviourites: 'api/v1/Associate/UpdateAssociateFavorite',
  threeThenFreeDetails: 'api/v1/Order/ThreeThenFreeDetails',
  getTygaBankWalletBalance: 'api/v1/Associate/GetTygaBankWalletBalance',
  merchantMapping: 'api/v1/Merchant/MerchantMapping',
  searchOrders: 'api/v1/Order/SearchOrder',
  updateSubscriptionItems: 'api/v1/Subscription/UpdateSubscriptionItem',
  updateServiceItems: 'api/v1/Subscription/UpdateServiceItem',
  getAssociateNeededAlerts: 'api/v1/Associate/GetAssociateNeededAlerts',
  // KYC endpoints
  getKYC: 'api/v1/Associate/GetKYC',
  addKYC: 'api/v1/Associate/AddKYC',
  updateKYC: 'api/v1/Associate/UpdateKYC',
  // KYC Admin endpoints
  getKYCPendingReview: 'api/v1/Associate/GetKYCPendingReview',
  getAllKYC: 'api/v1/Associate/GetAllKYC',
  approveKYC: 'api/v1/Associate/ApproveKYC',
  rejectKYC: 'api/v1/Associate/RejectKYC',
  requestMoreInfoKYC: 'api/v1/Associate/RequestMoreInfoKYC',
  assignKYC: 'api/v1/Associate/AssignKYC',
  getClientUiSettingByMetaType: 'api/v1/Configuration/GetClientUiSettingByMetaType',
  getAllRegions: 'api/v1/Product/GetAllRegions',
  addRegion: 'api/v1/Product/AddRegion',
  getRegionMap: 'api/v1/Product/GetRegionMap',
  assignRegion: 'api/v1/Product/AssignToRegion',
  deleteRegionMap: 'api/v1/Product/DeleteRegionMap',
  getAllRegionDetails: 'api/v1/Product/GetAllRegionDetails',
  updateRegion: 'api/v1/Product/UpdateRegion',
  getAllStatesByCode: 'api/v1/Product/GetAllStatesByCode',
  deleteRegion: 'api/v1/Product/DeleteRegion',
  getProducts: 'api/v1/Product/GetProducts',
  getParentSubAssociateSubscription:
    'api/v1/Subscription/GetParentSubAssociateSubscription',
  salesByMonthReport: 'api/v1/CompanyReport/SaleByMonthReport',
  salesPerDay: 'api/v1/Report/GetSalesPerDay',
  getCashFlowReport: 'api/v1/Report/GetCashFlowPerDay',
  salesBySKU: 'api/v1/Report/SalesBySKU',
  GetVolumeAdjustmentByOrder: 'api/v1/Order/GetVolumeAdjustmentByOrder',
};

// Pillars Api

const urlPillars = {
  passwordReset: '/api/v1/emailcontent/PasswordReset',
  emailSender: '/api/v1/emailSender',
};

export default urlConfigs;

export { urlPillars };
